import { FC } from "react";
import { Box, IconButton } from "@mui/material";
import {
  matchPath,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom";
import { CounterpartyMenu } from "../counterParty/menu";
import { CounterpartiesMenu } from "../counterparties/menu";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { RequestNewCounterpartyMenu } from "../requestNew/menu";
import { MyOnboardingRequestsMenu } from "../myRequests/menu";

type Props = {};

export const TradingCounterpartiesMenu: FC<Props> = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isOverview = /^\/tradingcounterparties\/?$/.test(location.pathname);
  const isSignoff = Boolean(
    matchPath(
      "/tradingcounterparties/counterparty/:id/signoff",
      location.pathname
    )
  );

  const nav = () =>
    isOverview
      ? navigate("/home")
      : isSignoff
        ? navigate(-1)
        : navigate("/tradingcounterparties");

  return (
    <Box display="flex" width="100%">
      <IconButton onClick={nav} sx={{ color: "secondary.main" }}>
        <ArrowBackIcon />
      </IconButton>
      <Box display="flex" alignItems="center" width="100%" minWidth={0}>
        <Routes>
          <Route path="counterparty/:id/*" element={<CounterpartyMenu />} />
          <Route path="request-new" element={<RequestNewCounterpartyMenu />} />
          <Route path="my-requests" element={<MyOnboardingRequestsMenu />} />
          <Route path="*" element={<CounterpartiesMenu />} />
        </Routes>
      </Box>
    </Box>
  );
};
